//@vendor
const immutable = require('immutable');
const React = require('react');
const PropTypes = require('prop-types');
const { isEmpty, isEqual } = require('lodash/lang');
const { sortByOrder } = require('lodash/collection');
//@commons
const { OKMessage } = require('commonsComponents/OKMessage');
const EditAddressForm = require('components/myProfile/myProfileEditor/EditAddressForm');
const OKModal = require('components/commons/OKModal/OKModal');
//@core
const { FormattedText } = require('core/i18n').i18n;
//@constants
const {
    provincesExcludeFromInput,
    retailLoanDoTaggin: {
        NAME_PAGE_WIZARD_VIEW,
        TAGGING_VIEW, TAGGING_SAVE,
        TAGGING_CLOSE, TAGGING_CANCEL,
    },
} = require('../../../../../loansConstants/index');
const { POSTAL_CODE_REGEX } = require('constants/index');
const PROVINCES = require('constants/provinces');
const PROVINCES_OPTIONS = Object.getOwnPropertyNames(PROVINCES).map(property => ({
    value: property,
    label: PROVINCES[property]
}));
const { TYPEOFROADS } = require('constants/typeOfRoads');
//@helpers
const { buildEventsModal } = require('../../../../../loansUtilities/loansHelper');
// @ utilities
const {
    recordLinkV2,
} = require('utilities/tagging');

class RetailLoanPersonalDataModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            callEventSubmit: false
        }
        this.buildDisclaimerChangeAddres = this.buildDisclaimerChangeAddres.bind(this);
        this.handleOnSubmitPersonalData = this.handleOnSubmitPersonalData.bind(this);
        this.onHandleEditValuePersonalData = this.onHandleEditValuePersonalData.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.loadPersonalData = this.loadPersonalData.bind(this);
    }

    componentWillMount() {
        this.loadPersonalData();
    }

    componentDidUpdate(prevProps) {
        const { showModal, tagModal } = this.props;

        if (prevProps.showModal !== showModal && showModal) {
            const customData = buildEventsModal(tagModal, TAGGING_VIEW, NAME_PAGE_WIZARD_VIEW);
            recordLinkV2(customData);
        }
    }

    handleToggleModal(typeCall, typeEvent) {
        const { onHandleToggleModal, tagModal } = this.props;
        if (isEqual(typeCall, 'close')) {
            this.loadPersonalData();
        }
        this.setState({
            callEventSubmit: false
        });
        onHandleToggleModal(tagModal, typeEvent);
    }

    loadPersonalData() {
        const { immRetailLoan, propEdit } = this.props;

        let personalData;
        if (isEqual(propEdit, 'personalData')) {
            personalData = immRetailLoan.get('personalData');
        } else if (isEqual(propEdit, 'otherAddress')) {
            personalData = immRetailLoan.get('otherAddress');
        } else {
            personalData = immRetailLoan.get('billingAddress');
        }

        this.setState({
            typeOfRoads: isEqual(personalData.get('typeOfRoads'), 0) ? TYPEOFROADS[0] : personalData.get('typeOfRoads'),
            streetName: personalData.get('streetName'),
            numberStreet: personalData.get('numberStreet'),
            restOfAddress: personalData.get('restOfAddress'),
            locality: personalData.get('locality'),
            postalCode: personalData.get('postalCode'),
            province: isEqual(personalData.get('province'), 0) ? sortByOrder(PROVINCES_OPTIONS, "label", "asc")[0].value : personalData.get('province')
        });
    }

    onHandleEditValuePersonalData(prop, value) {
        this.setState({ [prop]: value });
    }

    validateAddressForm() {
        const { locality, numberStreet, province, streetName, typeOfRoads, postalCode } = this.state;
        return !isEmpty(locality) && !isEmpty(numberStreet) && !isEmpty(province) &&
            !isEmpty(streetName) && !isEmpty(typeOfRoads) &&
            !isEmpty(postalCode) && postalCode.startsWith(province) && POSTAL_CODE_REGEX.test(postalCode);
    }

    buildDisclaimerChangeAddres() {
        const { propEdit } = this.props;
        const disclaimer = isEqual(propEdit, 'otherAddress') || isEqual(propEdit, 'billingAddress') ? "contractRetailLoanStepTwo-disclaimerPersonalDataOtherAddress"
            : "contractRetailLoanStepTwo-disclaimerPersonalData";
        return (
            <OKMessage type="important">
                <FormattedText value={disclaimer} />
            </OKMessage>
        );
    }

    handleOnSubmitPersonalData(event) {
        event.preventDefault();
        const { updatePersonalData, propEdit } = this.props;
        const response = this.validateAddressForm();
        if (response) {
            const personalData = {
                typeOfRoads: this.state.typeOfRoads,
                streetName: this.state.streetName,
                numberStreet: this.state.numberStreet,
                restOfAddress: this.state.restOfAddress,
                locality: this.state.locality,
                postalCode: this.state.postalCode,
                province: this.state.province
            };
            updatePersonalData({ prop: propEdit, personalData });

            this.handleToggleModal("save", TAGGING_SAVE);
        } else {
            this.setState({
                callEventSubmit: true
            })
        }
    }

    render() {
        const { showModal, propEdit, immProfileFields } = this.props;
        const personalDataValuesState = immutable.fromJS({
            typeOfRoads: this.state.typeOfRoads,
            streetName: this.state.streetName,
            numberStreet: this.state.numberStreet,
            restOfAddress: this.state.restOfAddress,
            locality: this.state.locality,
            postalCode: this.state.postalCode,
            province: this.state.province
        });
        const disclaimer = propEdit === "billingAddress" ? this.buildDisclaimerChangeAddres() : null;
        const modalContent = (
            <div className="container-fluid">
                <EditAddressForm
                    callEventSubmit={this.state.callEventSubmit}
                    handleEditValuePersonalData={this.onHandleEditValuePersonalData}
                    immProfileFields={immProfileFields}
                    personalData={personalDataValuesState}
                    provincesExlude={provincesExcludeFromInput}
                    propEdit={propEdit}
                    retailLoanCall
                />
                {disclaimer}
            </div>
        );

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={showModal}
                onCloseCallback={() => this.handleToggleModal("close", TAGGING_CLOSE)}
                onPrimaryButtonClick={this.handleOnSubmitPersonalData}
                onSecondaryButtonClick={() => this.handleToggleModal("close", TAGGING_CANCEL)}
                primaryButtonText="common-save"
                secondaryButtonText="common-cancel"
                size="large"
            />
        );
    }

}

RetailLoanPersonalDataModal.propTypes = {
    immRetailLoan: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    updatePersonalData: PropTypes.func,
    updateOtherAddress: PropTypes.func,
    onHandleToggleModal: PropTypes.func.isRequired,
    showModal: PropTypes.bool,
    propEdit: PropTypes.string.isRequired,
    tagModal: PropTypes.string,
};

module.exports = RetailLoanPersonalDataModal;
